App.filter('proposedDate', function() {
    return function(type) {
        if (type === 'life') {
            var date = new Date();
            var dayOfMonth = date.getDate();
            var requiredDayOfMonth = 20;
            var proposedDate = null;

            if (dayOfMonth <= requiredDayOfMonth) {
                // to najbliższy
                var date = new Date(date.getFullYear(), date.getMonth() + 1);
                var formattedDate = moment(date).format('YYYY-MM-DD');
                proposedDate = formattedDate;
            } else {
                // to +1 miesiąc
                var date = new Date(date.getFullYear(), date.getMonth() + 2);
                var formattedDate = moment(date).format('YYYY-MM-DD');
                proposedDate = formattedDate;
            }

            return proposedDate;
        } else {
            return null;
        }
    }
});
